import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxUpdateRegistrationFormDataParams,
  IIndirectTaxUpdateRegistrationFormDataResponse,
} from './types';

export async function updateIndirectTaxRegistrationFormData(
  registrationId: string,
  params: IIndirectTaxUpdateRegistrationFormDataParams
): Promise<{
  success: boolean;
  data?: IIndirectTaxUpdateRegistrationFormDataResponse;
  error?: string;
  isConflict?: boolean;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/registrations-v2/${registrationId}/form-data`,
      { method: 'POST', body: params },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to update registration form data',
        isConflict: response.status === 409,
      };
    }

    const data: IIndirectTaxUpdateRegistrationFormDataResponse =
      await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to update registration form data';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
